import "./tabs.css";
import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";

// Масив табів контролює їх кількість та зображення звідси
const tabs = [
  {
    id: 1,
    defaultImg: require("./img/calendar.svg").default,
    activeImg: require("./img/calendar_active.svg").default,
    alt: "Calendar",
    name: 'calendar',
  },
  {
    id: 2,
    defaultImg: require("./img/home.svg").default,
    activeImg: require("./img/home_active.svg").default,
    alt: "Home",
    name: 'home',
  },
  {
    id: 3,
    defaultImg: require("./img/account.svg").default,
    activeImg: require("./img/account_active.svg").default,
    alt: "Account",
    name: 'account',
  },
];

const TabPanel = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabContainerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const locationPath = location.pathname;

  // console.log(locationPath)

  const handleTabRoutes = (tabName) => () => {
    return tabName === 'account' ? navigate(Routes.userProfileUpdated) :
      tabName === 'home' ? navigate(Routes.mainPage) :
        tabName === 'calendar' ? navigate(Routes.calendarPage) :
          null;
  }

  useEffect(() => {
    if (locationPath === Routes.welcomePage ||
      locationPath === Routes.loginPage ||
      locationPath === Routes.userProfile ||
      locationPath === Routes.terms ||
      locationPath === Routes.unsubscription ||
      locationPath === Routes.unsubscriptionSuccess ||
      locationPath === Routes.testResults) {
      tabContainerRef.current.classList.add('tab-hidden');
    } else {
      tabContainerRef.current.classList.remove('tab-hidden');
    }

    if (locationPath === Routes.calendarPage) {
      setActiveTab(1);
    } else if (locationPath === Routes.mainPage) {
      setActiveTab(2);
    } else if (locationPath === Routes.userProfileUpdated) {
      setActiveTab(3);
    } else {
      setActiveTab(0);
    }
  }, [locationPath]);

  return (
    <div ref={tabContainerRef}
         className="tab-container">
      {tabs.map((tab) => (
        <div key={tab.id}
             data-name={tab.name}
             className={`tab-item ${activeTab === tab.id ? "active" : ""}`}
             onClick={handleTabRoutes(tab.name)}
        >
          <img
            className="tab-image"
            width='24'
            height='24'
            src={activeTab === tab.id ? tab.activeImg : tab.defaultImg}
            alt={tab.alt}
          />
        </div>
      ))}
    </div>
  );
};

export default TabPanel;
